module.exports = {
      id: "bookmark-outline-usage",
      viewBox: "0 0 24 36",
      url: "/" + "sprite-72169aba3aaebb7b19ede7951c92022d.svg#bookmark-outline",
      toString: function () {
        return this.url;
      }
    }